import { render, staticRenderFns } from "./AssetDepartamentsTable.vue?vue&type=template&id=a923de46"
import script from "./AssetDepartamentsTable.vue?vue&type=script&lang=js"
export * from "./AssetDepartamentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports